<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_22488_134398)">
      <path
        d="M11.0859 0.583984L10.3509 2.18815L8.7526 2.91732L10.3509 3.65232L11.0859 5.25065L11.8151 3.65232L13.4193 2.91732L11.8151 2.18815M5.2526 2.33398L3.79427 5.54232L0.585938 7.00065L3.79427 8.45898L5.2526 11.6673L6.71094 8.45898L9.91927 7.00065L6.71094 5.54232M11.0859 8.75065L10.3509 10.349L8.7526 11.084L10.3509 11.8132L11.0859 13.4173L11.8151 11.8132L13.4193 11.084L11.8151 10.349"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_22488_134398">
        <rect
          width="14"
          height="14"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
</template>
